module.exports = __webpack_public_path__ + "img/6e877cbade970043eaabd7d49d2d69c7.gif";